export const BackgroundColorChangeCaseStudies = (() => {
	'use strict';

	function init() {
		// if($('.case-study__intro').length){
		// 	let colorBg = $('.case-study__intro').css("background-color");
		// 	let nextSibling = $(".case-study__intro").next('.pxblock').height() + 200;
		// 	$('body').css({ 'background-color' : colorBg,'transition': '1600ms ease-in-out'});

		// 	var topofDiv = $(".case-study__intro").offset().top; //gets offset of header
		// 	var height = $(".case-study__intro").outerHeight(); //gets height of header

		// 	$(window).scroll(function(){
		// 		if ($(this).scrollTop() > (topofDiv + height + nextSibling)) {
		// 		   $('body').css({ 'background-color' : ''});
		// 		} else {
		// 		   $('body').css({ 'background-color' : colorBg});
		// 		}
		// 	});

		// }

	}

	return {
		init: init
	};
})();
